import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children", "onClick"];
import classNames from '@jd/jmtd-tools/es/classnames';
import PropTypes from 'prop-types';
import React from 'react'; // 下拉面板

export default function DropdownPanel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, other, {
    className: classNames('jmtd-dropdown-panel', className),
    onClick: onClick
  }), children);
}
DropdownPanel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func
};
DropdownPanel.defaultProps = {
  children: null,
  className: '',
  onClick: function onClick() {}
};